import AxiosInstance from "@/plugins/axios-vue";
import Vue from "vue";
import Vuex from "vuex";

const initStorePlugin = (store) => {
  let prevToken = localStorage.getItem("token");
  let prevExptimestamp = localStorage.getItem("exptimestamp") || 0;
  let prevSelectedUnit = localStorage.getItem("selectedUnit") || "all";

  if (prevExptimestamp > 0) {
    store.commit("setExptimestamp", prevExptimestamp);
  }
  if (prevToken) {
    store.commit("setToken", prevToken);
  }
  if (prevSelectedUnit) {
    store.commit("setSelectedUnit", prevSelectedUnit);
  }

  store.subscribe((mutation, state) => {
    if (mutation.type === "setToken" && prevToken !== mutation.payload) {
      localStorage.setItem("token", mutation.payload);
      prevToken = state.token;
    }

    if (
      mutation.type === "setExptimestamp" &&
      prevExptimestamp !== mutation.payload
    ) {
      localStorage.setItem("exptimestamp", mutation.payload);
      prevExptimestamp = state.exptimestamp;
    }

    if (
      mutation.type === "setSelectedUnit" &&
      prevSelectedUnit !== mutation.payload
    ) {
      localStorage.setItem("selectedUnit", mutation.payload);
      prevSelectedUnit = state.selectedUnit;
    }
  });
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    register: false,
    auth: {
      status: false,
      email: "",
    },
    user: {},
    initAuthCheck: true,
    isAuthCheckFailed: false,
    token: "",
    loading: false,
    exptimestamp: 0,
    moreFilters: null,
    selectedUnit: "all",
  },
  mutations: {
    setInitAuthCheck(state, val) {
      state.initAuthCheck = val;
    },
    setIsAuthCheckFailed(state, val) {
      state.isAuthCheckFailed = val;
    },
    setToken(state, val) {
      state.token = val;
    },
    setRegister(state, val) {
      state.register = val;
    },
    setAuth(state, val) {
      state.auth = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setUser(state, val) {
      state.user = val;
    },
    setMoreFilters(state, val) {
      state.moreFilters = val;
    },
    getProfile(state) {
      AxiosInstance.get("/myaccount").then((res) => {
        state.user = {
          ...state.user,
          ...res.data.data,
        };
      });
    },
    setExptimestamp(state, val) {
      state.exptimestamp = val;
    },
    // ✅ Tambahan mutation baru
    setSelectedUnit(state, val) {
      state.selectedUnit = val;
    },
  },
  actions: {},
  modules: {},
  plugins: [initStorePlugin],
});
